import {
  LayoutDashboard,
  Receipt,
  PiggyBank,
  Target,
  Repeat,
  FileText,
  FileSpreadsheet,
  Users,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const features = [
  {
    icon: LayoutDashboard,
    title: "Dashboard inteligente",
    description:
      "Visualize todas as suas finan\u00e7as em um painel completo com gr\u00e1ficos e indicadores em tempo real.",
  },
  {
    icon: Receipt,
    title: "Controle de transa\u00e7\u00f5es",
    description:
      "Registre receitas e despesas com categoriza\u00e7\u00e3o autom\u00e1tica e busca avan\u00e7ada.",
  },
  {
    icon: PiggyBank,
    title: "Planejamento financeiro",
    description:
      "Crie or\u00e7amentos mensais e anuais para manter seus gastos sob controle.",
  },
  {
    icon: Target,
    title: "Metas de economia",
    description:
      "Defina objetivos financeiros e acompanhe seu progresso com cofrinhos virtuais.",
  },
  {
    icon: Repeat,
    title: "Transa\u00e7\u00f5es recorrentes",
    description:
      "Automatize lan\u00e7amentos fixos como aluguel, sal\u00e1rio e assinaturas.",
  },
  {
    icon: FileText,
    title: "Relat\u00f3rios detalhados",
    description:
      "Analise seus h\u00e1bitos financeiros com relat\u00f3rios visuais por per\u00edodo e categoria.",
  },
  {
    icon: FileSpreadsheet,
    title: "DRE para MEI",
    description:
      "Gere demonstrativos de resultado para microempreendedores individuais.",
  },
  {
    icon: Users,
    title: "Compartilhamento",
    description:
      "Compartilhe contas com familiares ou s\u00f3cios com controle de permiss\u00f5es.",
  },
];

export function FeaturesShowcase() {
  return (
    <section id="features" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Tudo que voc&ecirc; precisa para organizar suas finan&ccedil;as
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Ferramentas poderosas e intuitivas para voc&ecirc; assumir o controle
            do seu dinheiro.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <Card
              key={feature.title}
              className="group hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="p-6 space-y-4">
                <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="font-semibold text-lg text-foreground">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
